// extracted by mini-css-extract-plugin
export default {"container":"container___I0jiE","step-content":"step-content___tCx3S","step-container":"step-container___JtijD","point":"point___F9q29","big-point":"big-point___gm3v2"};